import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_IDENTITY } from '../approvals/newSiteWords';
import { useAddons } from './addons';
import { InkSection } from './shared';

/**
 * Website › Pages › Page settings: only what's true today. The design's "Add new
 * pages to the header" and landing page rules aren't built, so they aren't here
 * (no "Coming soon" notes, owner 2026-10-22).
 */
export function CmsPageSettings() {
  const { flatNav } = useAddons();
  return (
    <div className="ink-body">
      <div className="ink-site-settings-head">
        <Link to="/content?view=pages" className="ink-back-link">
          ← Pages
        </Link>
        {flatNav ? (
          <>
            <h1 className="ink-h1">Manage</h1>
            <h2 className="ink-manage-subtitle">Page settings</h2>
          </>
        ) : (
          <h1 className="ink-h1">Page settings</h1>
        )}
        <p className="ink-lede">How pages go live. Your agent follows these too.</p>
      </div>
      <InkSection
        id="publishing"
        title="Publishing"
        description="Applies to every page, including the header and footer."
      >
        <div className="ink-site-card">
          <div className="ink-site-row">
            <span>
              <span className="ink-site-row-title">Approve pages before they go live</span>
              <span className="ink-site-row-desc" style={{ display: 'block' }}>
                New pages and changes wait for you in Pages and in To approve.
              </span>
            </span>
            <span className="ink-media-rule">Always on</span>
          </div>
          <div className="ink-site-row">
            <span>
              <span className="ink-site-row-title">Header and footer</span>
              <span className="ink-site-row-desc" style={{ display: 'block' }}>
                The links readers see on every page, edited with your pages.
              </span>
            </span>
            <Link to="/content?view=pages" className="ink-site-open">
              Open Pages →
            </Link>
          </div>
          <div className="ink-site-row">
            <span>
              <span className="ink-site-row-title">Default social image</span>
              <span className="ink-site-row-desc" style={{ display: 'block' }}>
                Used in link previews when a page has none of its own.
              </span>
            </span>
            <Link to={SITE_IDENTITY} className="ink-site-open">
              Open Site →
            </Link>
          </div>
        </div>
      </InkSection>
    </div>
  );
}
